import { jsx as r, Fragment as p, jsxs as n } from "react/jsx-runtime";
import { aQ as o } from "../../../vendor-Dd6qj6gJ.js";
import { SearchField as c } from "../../SearchField/index.js";
import '../../../assets/index48.css';const i = "_searchFieldWrapper_zj3rm_1", l = {
  searchFieldWrapper: i
}, d = ({
  search: e,
  children: t,
  searchPlaceholder: a
}) => e ? /* @__PURE__ */ n(o, { inputValue: e.value, onInputChange: e.onInput, children: [
  /* @__PURE__ */ r("div", { className: l.searchFieldWrapper, children: /* @__PURE__ */ r(
    c,
    {
      "aria-label": a,
      placeholder: a,
      fullWidth: !0,
      autoFocus_I_READ_THE_JSDOC: !0
    }
  ) }),
  t
] }) : /* @__PURE__ */ r(p, { children: t });
export {
  d as SelectMenuContent
};
